import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { queryClient } from "../../api/queryClient.js";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  clinicIds: yup.array().of(yup.number()).required(),
});

export function useSetClinicsObOrderMutation(options = {}) {
  return useMutation(
    (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.post(HTTP_ENDPOINTS.setClinicsObOrder(), {
        ids: req.clinicIds,
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.clinicsObOrder],
        });
        options?.onSuccess?.(...args);
      },
    },
  );
}
